import React from "react"

// Styles
import useStyles from "./styles"

type ModernButtonProps = {
    variant?: "ghost" | "primary" | "ok"
    loading?: boolean
    disabled?: boolean
    title?: string
    className?: string
    onClick(): void
    children: React.ReactNode
}

/**
 * The Modern skin's button.
 *
 * @param props
 */
export default function ModernButton(props: ModernButtonProps) {
    const styles = useStyles();
    const {variant = "ghost", loading = false, disabled = false, title, className, onClick, children} = props;

    const variants: {[key: string]: string} = {
        ghost: "",
        primary: styles.btn__primary,
        ok: styles.btn__ok,
    };

    return (
        <button
            type="button"
            className={`${styles.btn} ${variants[variant] || ""} ${className || ""}`}
            disabled={disabled || loading}
            title={title}
            onClick={onClick}
        >
            {loading && <span className={styles.spinner} aria-hidden="true"/>}
            {children}
        </button>
    )
}
